import * as React from "react";
import styled, { css } from "styled-components";

import { Icon } from "src/library/components/Icon";
import HtmlBody from "src/library/components/Notes/HtmlBody";
import { Text } from "src/library/components/Text";
import { IError } from "src/core/errors/api/errors.api";
import { IRole } from "src/core/shared/api/roles.api";
import { Icons } from "src/library/components/Icon/types";

interface ErrorNoteProps {
  error: IError;
  currentRole: IRole;
  handleClick: () => void;
}

const ErrorNote: React.ReactFCWithChildren<ErrorNoteProps> = ({
  error, currentRole, handleClick
}) => {
  return (
    <Container>
      <Wrapper
        className={`${error.status} ${currentRole.type === "admin" ? "admin" : ""}`}
        onClick={() => {
          if (currentRole.type === "admin") {
            handleClick();
          }
        }}
      >
        <Icon
          $fillColor={error.status === "active" ? "error" : error.status === "deprecated" ? "lightGrey" : "success"}
          size={15}
          icon={error.status === "active" || error.status === "deprecated" ? Icons.ERRORCIRCLE : Icons.TICK}
        />

        {error.note && (
          <div className="errorHtml">
            <HtmlBody body={error.note} />
          </div>
        )}

        <Text className="resolved">
          {error.status === "resolved" && " (resolved)"}
        </Text>
      </Wrapper>
    </Container>
  );
};

const Container = styled.div`
  margin-top: ${({ theme }) => theme.spacing.margins.xs};
  display: flex;

  &:first-child {
    margin-top: 0;
  }
`;

const Wrapper = styled.div`
  ${({ theme }) => css`
    border-radius: ${theme.borderRadius};
    background: white;
    padding: ${theme.spacing.padding.md};
    display: inline-flex;
    width: 100%;
    position: relative;

    &.active.admin {
      cursor: pointer;
    }

    &.resolved,
    &.deprecated {
      opacity: 0.5;
    }

    svg {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: ${theme.spacing.margins.sm};
    }

    .errorHtml {
      display: block;
      padding-right: 100px;
      margin-left: calc(15px + ${theme.spacing.margins.sm});
    }

    .resolved {
      position: absolute;
      top: ${theme.spacing.margins.sm};
      right: ${theme.spacing.margins.sm};
    }
  `}
`;

export default ErrorNote;
